import React from "react";
import { Document, Page } from "react-pdf";
import PDFControls from "./PDFControls";
import PositionPreview from "./PositionPreview";
import Loader from "./Loader";

const PDFViewer = ({
  pdfUrl,
  currentPage,
  numPages,
  setNumPages,
  scale,
  signaturePositions,
  isSelectingPosition,
  onPageChange,
  onScaleChange,
  onPdfClick,
  containerRef,
  handleMouseMove,
  cursorPosition,
  handleRemoveSign,
}) => {
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    onPageChange(1);
  };

  return (
    <div>
      <h2 className="ps-heading">Document Preview</h2>

      <PDFControls
        numPages={numPages}
        currentPage={currentPage}
        setCurrentPage={onPageChange}
        scale={scale}
        setScale={onScaleChange}
      />

      <div
        ref={containerRef}
        className="ps-pdf-container"
        onClick={onPdfClick}
        style={{ cursor: isSelectingPosition ? "none" : "default" }}
        onMouseMove={handleMouseMove}
      >
        <Document
          file={pdfUrl}
          onLoadSuccess={onDocumentLoadSuccess}
          loading={<Loader size="large" text="Loading PDF…" />}
        >
          <Page
            pageNumber={currentPage}
            scale={scale}
            renderTextLayer={false}
            renderAnnotationLayer={false}
          />

          <PositionPreview
            containerRef={containerRef}
            currentPage={currentPage}
            positions={signaturePositions}
            handleRemoveSign={handleRemoveSign}
          />

          {/* Custom cursor */}
          {isSelectingPosition && (
            <div
              className="ps-custom-cursor"
              style={{
                left: `${cursorPosition.x}px`,
                top: `${cursorPosition.y}px`,
              }}
            >
              <span className="ps-cursor-symbol">+</span>
            </div>
          )}
        </Document>
      </div>
    </div>
  );
};

export default PDFViewer;
